module.exports = __webpack_public_path__ + "media/public/fonts/QanelasRegular/QanelasRegular-b2217a710166b8ae9a746b139cd284c9.eot";